export default "__VITE_ASSET__Im0zA214__"